<div class="result-container">
  <div class="text-truncate" [fastTooltip]="item().title">
    <span class="title">
      <semeris-traffic-light [quality]="transaction()?.qualityTrafficLight"> </semeris-traffic-light>
      <span class="title-text" [innerHTML]="item().title | boldSpan: term() | safeHtml"></span>
      @if (transaction()?.private) {
        <mat-icon fastTooltip="Private deal - Visible in your organization only" class="private-deal-icon"
          >lock</mat-icon
        >
      }
      @if (transaction()?.autoPublished) {
        <mat-icon fastTooltip="Auto Published" class="auto-published-icon">flash_auto</mat-icon>
      }
      @if (transaction()?.mostRecentIssue) {
        <semeris-latest-issuance (clicked)="onClose()" mode="icon" [transaction]="transaction()?.mostRecentIssue"></semeris-latest-issuance>
      }
    </span>
    <span class="subtitle" [innerHTML]="description() | boldSpan: term() | safeHtml"></span>
    <div class="type-parent">
      @if (transaction()?.issuanceType; as issuanceType) {
        <span class="type">{{ issuanceType | uppercase }}</span>
      }
      @if (transaction()?.endOfLife) {
        <span class="type" fastTooltip="End of Life">{{ transaction()?.issuanceType ? ('END OF LIFE' | prefix) : 'END OF LIFE' }}</span>
      }
    </div>
  </div>

  <div class="actions">
    @if (transaction()?.libraryDisplayName) {
      <div
        [fastTooltip]="transaction().libraryDisplayName + ' document library'"
        class="angular-chip without-margin"
      >
        {{ transaction().libraryDisplayName }}
      </div>
    }
    <semeris-add-remove-control
      itemCartSource
      itemCartSourceTarget="basket"
      [isAdd]="!transaction()?.selected"
      (add)="onAdd(item())"
      (remove)="onRemove(item())"
    ></semeris-add-remove-control>
  </div>
</div>
